import { render, staticRenderFns } from "./WithdrawalRequestView.vue?vue&type=template&id=de507028&scoped=true"
import script from "./WithdrawalRequestView.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestView.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequestView.vue?vue&type=style&index=0&id=de507028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de507028",
  null
  
)

export default component.exports